import React, { useState, useContext } from "react";
import { GlobalContext } from "../../context/provider";
import deleteaction from "../../context/action/category/deleteaction";
import updateaction from "../../context/action/category/updateaction";
const Editcategorymodal = (props) => {
  const { initState, recaller, setrecaller, clear, initDispatch } =
    useContext(GlobalContext);

  const [error, seterror] = useState(false);
  const [error1, seterror1] = useState(false);
  return (
    <div>
      <>
        {props.show ? (
          <>
            <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
              <div className="relative my-6 mx-auto w-11/12 sm:w-5/6 md:w-2/3 lg:w-1/2 max-w-2xl">
                {/*content*/}
                <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                  {/*header*/}
                  <div className="flex items-start justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                    <h3 className="text-xl sm:text-2xl md:text-3xl uppercase font-semibold flex-1">
                      گۆڕانکاری
                    </h3>
                    <button
                      className="p-1 ml-auto bg-transparent border-0 text-black opacity-80 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                      onClick={() => props.setshow(false)}
                    >
                      <span className="bg-transparent text-black h-6 w-6 text-2xl block outline-none focus:outline-none">
                        X
                      </span>
                    </button>
                  </div>
                  {/*body*/}
                  <div className="relative p-4 sm:p-6 flex-auto">
                    <div className="grid grid-cols-1 gap-4 w-full">
                      <div className="w-full">
                        <label
                          className={
                            error
                              ? "block uppercase tracking-wide text-red-500 text-xs font-bold mb-2"
                              : "block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                          }
                          htmlFor="category"
                        >
                          کاتیگۆری
                        </label>
                        <input
                          className={
                            error
                              ? "appearance-none block w-full bg-gray-50 text-gray-700 border border-red-500 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 h-12"
                              : "appearance-none block w-full bg-gray-50 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 h-12"
                          }
                          id="category"
                          type="text"
                          placeholder=""
                          onClick={(val)=>{val.target.select()}}
                          value={props.category_name}
                          onChange={(val) =>
                            props.setcategory_name(val.target.value)
                          }
                          onFocus={() => seterror(false)}
                        />
                      </div>
                      <div className="w-full">
                        <label
                          className={
                            error1
                              ? "block uppercase tracking-wide text-red-500 text-xs font-bold mb-2"
                              : "block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
                          }
                          htmlFor="category_start_code"
                        >
                          کۆدی دەستپێک
                        </label>
                        <input
                          className={
                            error1
                              ? "appearance-none block w-full bg-gray-50 text-gray-700 border border-red-500 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 h-12"
                              : "appearance-none block w-full bg-gray-50 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 h-12"
                          }
                          id="category_start_code"
                          type="text"
                          placeholder=""
                          onClick={(val)=>{val.target.select()}}
                          value={props.category_start_code}
                          onChange={(val) =>
                            props.setcategory_start_code(val.target.value)
                          }
                          onFocus={() => seterror1(false)}
                        />
                      </div>
                    </div>
                  </div>
                  {/*footer*/}
                  <div className="flex flex-col sm:flex-row items-center justify-end gap-3 p-4 sm:p-6 border-t border-solid border-slate-200 rounded-b">
                    <button
                      className="w-full sm:w-auto bg-red-500 text-white active:bg-red-600 font-bold uppercase text-sm px-4 sm:px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150 order-2 sm:order-1"
                      type="button"
                      onClick={() => {
                        if (
                          window.confirm("ئاگاداری ڕەشکردنەوە . دڵنیای ؟") ==
                          true
                        ) {
                          deleteaction(props.category_id)(recaller)(
                            setrecaller
                          )(initDispatch)(clear);
                        }
                      }}
                    >
                      ڕەشکردنەوە
                    </button>
                    <button
                      className="w-full sm:w-auto bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-4 sm:px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150 order-1 sm:order-2"
                      type="button"
                      onClick={() => {
                        if (props.category_name.trim() == "" || !props.category_name) {
                          seterror(true);
                          return false;
                        }
                        if (props.category_start_code.trim() == "" || !props.category_start_code) {
                          seterror1(true);
                          return false;
                        }
                        if (
                          window.confirm(
                            "ئاگاداری ئەنجامدانی گۆڕانکاری . دڵنیای ؟"
                          ) == true
                        ) {
                          updateaction(
                            props.category_name,
                            props.category_start_code,
                            props.category_id
                          )(recaller)(setrecaller)(initDispatch)(clear);
                        }
                      }}
                    >
                      گۆڕانکاری
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
          </>
        ) : null}
      </>
    </div>
  );
};

export default Editcategorymodal;
